import { FlexBox, Spinner } from '@dixa/lib-shared-habla';
import type { EditorProps } from '@monaco-editor/react';
import { lazy, Suspense } from 'react';

type EditorLoadingIndicatorProps = {
  height: number | string;
};

const EditorLoadingIndicator = ({ height }: EditorLoadingIndicatorProps) => (
  <FlexBox
    alignItems="center"
    justifyContent="center"
    style={{
      height: `${height}px`,
    }}
  >
    <Spinner bgColor="#1e1e1e" />
  </FlexBox>
);

export const Editor = lazy(() =>
  import('@monaco-editor/react').then((mod) => ({
    default: mod.Editor,
  })),
);

export function EditorWithLoading(props: EditorProps): JSX.Element {
  const height = props.height || 240;
  return (
    <Suspense fallback={<EditorLoadingIndicator height={height} />}>
      <Editor {...props} />
    </Suspense>
  );
}
